import service from './index'
import type { AcMenuItem } from '../types/acMenu'

const prefix = "/freyr-tm";

/** All configured Admin Center SideMenu items (all modules). No domainId. */
export const getAllAcMenus = (): Promise<API.DataResponse<AcMenuItem[]>> =>
  service.get(`${prefix}/tmModule/ac-menu/all`);

export const fetchTenantPageList = () => service.get(`${prefix}/tmTenant/basicList`);

export const fetchModuleList = (tenantId: string) => service.get(`${prefix}/tmModule/onboardedAndQuicksightEnabled/${tenantId}`);

export const fetchSubscriptionModuleList = (tenantId: string) => service.get(`${prefix}/tmSubscription/getByTenantId/${tenantId}`);

export const fetchDomainList = () => service.get(`${prefix}/tmDomain/list`);

export const fetchModuleListForMenu = (
  tenantId: string
): Promise<API.DataResponse<API.SubscriptionModule[]>> => service.get(`${prefix}/tmSubscription/modules?tenantId=${tenantId}`);

export const fetchModuleListForMenuV2 = (
  tenantId: string
): Promise<API.DataResponse<API.SubscriptionModule[]>> => service.get(`${prefix}/tmSubscription/modules/v2?tenantId=${tenantId}`);

export const getTenantInfo = (id: string) => service.get(`${prefix}/tmTenant/${id}`);
export const apiGetTenantFeaturesList = (moduleId: string, tenatId: string): Promise<API.DataResponse<API.FeatureFlagsData>> =>
  service.get(`${prefix}/tmTenant/feature-flags?tenantId=${tenatId}&moduleId=${moduleId}`);

/** Find objects configured on a tmModule by module ID */
export const apiGetModuleObjects = (
  moduleId: string
): Promise<API.DataResponse<API.ModuleObject[]>> =>
  service.get(`${prefix}/tmModule/objects`, { params: { moduleId } });
